import { render, staticRenderFns } from "./IntegratorBranchAndCompanyConfigTab.vue?vue&type=template&id=5b7636f9"
import script from "./IntegratorBranchAndCompanyConfigTab.vue?vue&type=script&lang=ts"
export * from "./IntegratorBranchAndCompanyConfigTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports